/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_TitleInputs */

const en_admin_funnel_title = /** @type {(inputs: Admin_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funnel dashboard`)
};

/**
* | output |
* | --- |
* | "Funnel dashboard" |
*
* @param {Admin_Funnel_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_title = /** @type {((inputs?: Admin_Funnel_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_title(inputs)
});
export { admin_funnel_title as "admin.funnel.title" }